import React, { DetailedHTMLProps, FC } from 'react';
import cn from 'classnames';

type ItemProps = {
  className?: string;
  hidden?: boolean;
} & DetailedHTMLProps<React.LiHTMLAttributes<HTMLLIElement>, HTMLLIElement>;

const UpsellListItem: FC<ItemProps> = ({
  children,
  className = '',
  hidden,
  ...rest
}) => (
  <>
    <li
      {...rest}
      className={cn(
        `${className}`,
        'md:border-l md:relative md:last:border-0 md:first:pt-25 last:pb-20 md:last:pb-none Upsell-Item',
        hidden && 'hidden',
      )}
    >
      {children}
    </li>
  </>
);

export default UpsellListItem;
